module.exports = __webpack_public_path__ + "media/assets/btn-plus-b113812053c10f81bb20139a6cddc339.svg";